import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Share = createReactComponent("Share", ["svg", defaultAttributes, [["path", {
  d: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8",
  key: "d70k5s"
}], ["polyline", {
  points: "16 6 12 2 8 6",
  key: "yk6rbx"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "15",
  key: "telubq"
}]]]);
export default Share;